function getCookie(name) {
  let cookieValue = null;

  if (document.cookie && document.cookie !== "") {
    const cookies = document.cookie.split(";");

    for (let i = 0; i < cookies.length; i++) {
      const cookie = cookies[i].trim();
      if (cookie.startsWith(name + "=")) {
        cookieValue = decodeURIComponent(cookie.split("=")[1]);
        break;
      }
    }
  }
  return cookieValue;
}

export function getCSRFToken() {
  const token = getCookie("csrftoken");

  return token;
}

export async function fetchCSRFToken() {
  try {
    const response = await fetch("/api/_allauth/browser/v1/config", {
      method: "GET",
      credentials: "include",
    });

    if (!response.ok) throw new Error("Failed to fetch CSRF token");

    const newToken = getCSRFToken();
    if (newToken) {
      return newToken;
    } else {
      throw new Error("CSRF token not found in cookies.");
    }
  } catch (error) {
    console.error("Error fetching CSRF token:", error);
    throw error;
  }
}
